import { SwitchItem } from "./Switch";

export default function getNextItem<T extends string>(
  items: SwitchItem<T>[],
  value: string
) {
  const index = items.findIndex((item) => item.value === value);

  if (index === items.length - 1) {
    return items[0];
  } else {
    return items[index + 1];
  }
}
